import { InfobarState, SidebarState } from "./types";

export enum SidebarAction {
  SET_IS_OPEN = 'SET_IS_OPEN',
  SET_SIDEBAR = 'SET_SIDEBAR',
  SET_INFOBAR_IS_OPEN = 'SET_INFOBAR_IS_OPEN',
  SET_INFOBAR = 'SET_INFOBAR'
}

export const updateSidebar = (data: SidebarState) => ({
  type: SidebarAction.SET_SIDEBAR,
  data
})

export const openSidebar = () => ({
  type: SidebarAction.SET_IS_OPEN,
  data: true
})

export const closeSidebar = () => ({
  type: SidebarAction.SET_IS_OPEN,
  data: false
})

export const updateInfobar = (data: InfobarState) => ({
  type: SidebarAction.SET_INFOBAR,
  data
})

export const openInfobar = () => ({
  type: SidebarAction.SET_INFOBAR_IS_OPEN,
  data: true
})

export const closeInfobar = () => ({
  type: SidebarAction.SET_INFOBAR_IS_OPEN,
  data: false
})
